type Props = {
  className?: string;
};

export default function ScamflagLogo({ className = 'w-10 h-10' }: Props) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Shield rim — lighter red for depth */}
      <path
        d="M50 6L18 21V50C18 72 50 92 50 92C50 92 82 72 82 50V21L50 6Z"
        fill="#FF2D3F"
      />
      {/* Shield body — primary red */}
      <path
        d="M50 10L22 23V50C22 69 50 87 50 87C50 87 78 69 78 50V23L50 10Z"
        fill="#E8192C"
      />
      {/* Inner shield cavity — dark */}
      <path
        d="M50 16L28 27V50C28 65 50 80 50 80C50 80 72 65 72 50V27L50 16Z"
        fill="#1A1A1A"
      />

      {/* Eye — white sclera */}
      <ellipse cx="50" cy="48" rx="20" ry="14" fill="#FFFFFF" />

      {/* Iris — deep red */}
      <circle cx="50" cy="48" r="9" fill="#9B1015" />

      {/* Pupil — dark */}
      <circle cx="50" cy="48" r="4.5" fill="#1A1A1A" />

      {/* Eye highlight */}
      <circle cx="53" cy="45" r="1.8" fill="#FFFFFF" />

      {/* Scan ring — purple secondary accent */}
      <circle
        cx="50"
        cy="48"
        r="22"
        fill="none"
        stroke="#6C3FC4"
        strokeWidth="2"
        strokeDasharray="4 3"
        opacity="0.9"
      />
      {/* Scan ring tick marks for "active detection" feel */}
      <line x1="50" y1="22" x2="50" y2="27" stroke="#6C3FC4" strokeWidth="2" strokeLinecap="round" />
      <line x1="50" y1="69" x2="50" y2="74" stroke="#6C3FC4" strokeWidth="2" strokeLinecap="round" />
      <line x1="24" y1="48" x2="29" y2="48" stroke="#6C3FC4" strokeWidth="2" strokeLinecap="round" />
      <line x1="71" y1="48" x2="76" y2="48" stroke="#6C3FC4" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
